export class PasswordGroupRightsEnum {
    /*    
    public static int ROLE_DEFAULT = 0;
    public static int ROLE_OWNER = 1;
    public static int ROLE_DELEGATED_ADMIN = 2;
    public static int ROLE_READ_WRITE = 3;
    public static int ROLE_READ_ONLY = 4;
    */
    static readonly ROLE_DEFAULT = 0;
    static readonly ROLE_OWNER = 1;
    static readonly ROLE_DELEGATED_ADMIN = 2;
    static readonly ROLE_READ_WRITE = 3;
    static readonly ROLE_READ_ONLY = 4;

}